export default __webpack_public_path__ + "static/media/j47.a4afb02b.jpg";